import { graphql } from '@/gql';

export const UpdatePerformanceIpptResultsMutation = graphql(`
    mutation UpdatePerformanceIpptResults($id: ObjectID!, $input: UpdateIpptResultInput!) {
        updateIpptResult(id: $id, input: $input) {
            ... on UpdateIpptResultSuccessfulResponse {
                result {
                    ...IpptAssessmentResult
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);
